export default __webpack_public_path__ + "static/media/layer05.d5383b5d.png";